export default () => ({
    showNewAddress: false,
    activeEditAddressId: 0,

    init() {
        if (Shopify && Shopify.CountryProvinceSelector) {
            const newCountrySelectId = 'AddressCountryNew'
            const newCountrySelect = document.getElementById(newCountrySelectId)

            new Shopify.CountryProvinceSelector(newCountrySelectId, 'AddressProvinceNew', {
                hideElement: 'AddressProvinceContainerNew'
            })

            this.updateSelectPlaceholder(newCountrySelect, 'COUNTRY')

            const allOtherCountrySelects = document.querySelectorAll('[data-address-country-selector]')
            allOtherCountrySelects.forEach(select => {
                const addressId = select.dataset.addressId

                new Shopify.CountryProvinceSelector(`AddressCountryEdit_${addressId}`, `AddressProvinceEdit_${addressId}`, {
                    hideElement: `AddressProvinceContainerEdit_${addressId}`
                })

                this.updateSelectPlaceholder(select, 'COUNTRY')
            })
        }
    },

    toggleNewAddress() {
        this.showNewAddress = !this.showNewAddress
    },
    editAddress(id) {
        this.activeEditAddressId = id
    },
    updateSelectPlaceholder(select, label) {
        const selectPlaceholder = select.options[0]
        selectPlaceholder.textContent = label
        selectPlaceholder.setAttribute('disabled', true)
    }
})
